import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-exito',
  templateUrl: './modal-exito.component.html',
  styleUrls: ['./modal-exito.component.css']
})
export class ModalExitoComponent implements OnInit {

  mensaje: string = '';
  
  constructor(private modal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  onClickDismiss(event:Event,res:string):void{
    this.modal.dismiss(res);
  };
}
